module.exports = __webpack_public_path__ + "static/bimbadgen-0f2d4e8b990d3f66195cdedf1b8fbadc.jpg";